import React, { useContext, useState } from 'react';
import CompanyContext from '../../../contexts/company/CompanyContext';
import AdminOnlyModal from './AdminOnlyModal';

// Blocks a page to supervisors only: a member sees the admin-only modal instead of the
// wrapped page, which never mounts.
const RequireSupervisor: React.FC<React.PropsWithChildren> = ({ children }) => {
  const { activeCompany } = useContext(CompanyContext);
  const [isModalOpen, setIsModalOpen] = useState(true);

  if (activeCompany?.isSupervisor) return <>{children}</>;

  return <AdminOnlyModal isOpen={isModalOpen} onDismiss={() => setIsModalOpen(false)} />;
};

export default RequireSupervisor;
